<template>
  <div class="login-container">
    <div class="middle-pane">
      <div class="form-container">
        <div class="logo">
            <img src="../assets/icon.png" alt="Logo" />
          </div>
        <h1 style="width: 100%; text-align: center; align-items: center; justify-content: center;"><b>Connexion</b></h1>
        <form v-on:submit.prevent="connect()">
          <div class="input-field">
            <label for="email">Identifiant</label>
            <input type="text" id="email" v-model="post.email" required>
          </div>
          <div class="input-field">
            <label for="password">Mot de passe</label>
            <input type="password" id="password" v-model="post.pwd" required>
          </div>
          <div class="button-container">
            <button type="submit" class="login-button"><b>CONNEXION</b></button>
          </div>
        </form>
      </div>

    </div>
  </div>
</template>

<script>
import conf from '../config/api.js';
import script from '../script/script.js';

export default {
  data() {
    return {
      post: {},
      modalOublieMDP: { title: "Formulaire d'oubli de mot de passe", content: '' },
      loginOublie: ""
    }
  },
  created: function () {
    this.isConnect();
  },
  methods: {
    connect() {
      this.axios.post(conf.server + "/api/connect", this.post, { withCredentials: true })
        .then((response) => {
          if (response.status == 200) {
            localStorage.setItem('socid', response.data.socId)
            localStorage.setItem('userid', response.data.id)
            var user = this.axios.get(conf.server+"/api/users/"+response.data.id, {withCredentials: true})
            user.then(result=>{
              if(result.data.admin=="0"){
                localStorage.setItem('admin', result.data.admin)
              this.$router.push('/feuilles-de-temps/'+result.data.id);
            }
            else if(result.data.admin=="1"){
              localStorage.setItem('admin', result.data.admin)
              this.$router.push('/')
            }
            })
          }
        })
        .catch(() => {
          this.$bvToast.toast(`Identifiant ou mot de passe incorrect`, {
            title: 'Identification',
            toaster: 'b-toaster-bottom-right',
            variant: 'danger',
            autoHideDelay: 5000,
            appendToast: true,
            solid: true,
          })
        })
    },
    isConnect: script.isConnect,
    openModal(target) {
      this.$root.$emit('bv::show::modal', 'modalOublieMDP', target);
    },
    changePassOublie: script.changePassOublie
  }
}
</script>

<style scoped>
.login-container {
  display: flex;
  background: #ddd;
  justify-content: center;
  align-items: center;
  height: 100vh;
}

.middle-pane {
  border-radius: 75px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #fff;
  height: 65%;
  width: 40%;
  box-shadow: 0px 0px 35px 45px rgba(0, 0, 0, 0.1);
}

.form-container {
  width: 60%;
}

.logo img {
  display: block;
  margin-left: auto;
  margin-right: auto;
  width: 35%;
  /* Adjust as needed */
}

.input-field {
  margin-top: 50px;
  margin-bottom: 50px;
}

.input-field label {
  display: block;
}

.input-field input {
  width: 100%;
  outline: 0;
  border-color: #ccc;
  border-width: 0 0 2px;
  margin-top: 0.5rem;
}

.input-field input:focus {
  border-color: #ffa500;
  outline: 0px #000;
}

.button-container{
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.login-button {
  background-color: #ffa500;
  /* Customize to match your brand */
  color: white;
  border: none;
  padding: 1rem 2rem;
  margin-top: 1rem;
  cursor: pointer;
  width: 50%;
  border-radius: 20px;
  /* Rounded corners for the button */
}

@media (max-width: 768px) {
  .login-container {
    flex-direction: column;
  }

  .left-pane,
  .right-pane {
    flex: none;
    width: 100%;
  }

  .form-container {
    margin-top: 2rem;
  }
}
</style>
